/**
* Created by Omar Alejandro Leonor Avalos on 2017-06-06.
* Item model for each "despacho"
*/
import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Edit from 'material-ui/svg-icons/content/create';
import Block from 'material-ui/svg-icons/content/block';
import Trash from 'material-ui/svg-icons/action/delete';
import Guardar from 'material-ui/svg-icons/content/save';
import { EditableInlineV2 } from '../../../components/text';
import IconButton from 'material-ui/IconButton';
import { setValueIn } from '../../../common/immutable';
import { parsePath, getValueFromSelectList } from '../../../common/helpers';
import { Alert } from '../../../components/data-containers';
import Checkbox from 'material-ui/Checkbox';

const boolToText = (value) => {
    if (value === true) {
        return 'Sí';
    }
    return 'No';
};

class Item extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            customsHouse: props.customsHouse,
            openAlert: false
        };
    }

    updateCustomsHouse(path, value) {
        const customsHouse = setValueIn(parsePath(path), value, this.state.customsHouse);
        this.setState({ customsHouse });
    }

    renderButtons(editing, customsHouse, onSave) {
        const { allowUpdate, allowDelete } = this.props;
        return (
            <div className="space-around">
                {
                    editing && <IconButton
                        tooltip="Cancelar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => this.setState({ editing: false, customsHouse })}
                    >
                        <Block />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    editing && <IconButton
                        tooltip="Guardar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            this.setState({ editing: false });
                            onSave(this.state.customsHouse);
                        }}
                    >
                        <Guardar />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowUpdate) && <IconButton
                        tooltip="Editar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (!allowUpdate) { return; }
                            this.setState({ customsHouse: customsHouse })
                            this.setState({ editing: true });
                            this.setState({ customsHouse: customsHouse })
                        }}
                    >
                        <Edit />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowDelete) && <IconButton
                        tooltip="Eliminar Aduana"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            this.setState({ openAlert: true });
                        }}
                    >
                        <Trash />
                    </IconButton>
                }
            </div>
        );
    }

    updateCheck() {
        this.updateCustomsHouse('ownOffice', !this.props.customsHouse.ownOffice)
    }

    render() {
        const { editing } = this.state;
        const { customsHouse, onSave, actions } = this.props;
        const currentProperties = editing ? this.state.customsHouse : customsHouse;
        const { name, customsNumber, section, ownOffice } = currentProperties;

        return (
            <div className="col-md-12 margin-bottom-2">
                <div className="row item-row">
                    <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 white-card padding-2 vcenter ">
                        <div className="col-lg-12 col-md-8 col-xs-12 vcenter">
                            <EditableInlineV2
                                type="text"
                                editViewActive={editing}
                                value={name}
                                label='Nombre'
                                notify={(value) => this.updateCustomsHouse('name', value)}
                            />
                        </div>
                        <div className="col-lg-4 col-md-2 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="text"
                                editViewActive={editing}
                                value={customsNumber}
                                label='Número aduana'
                                notify={(value) => this.updateCustomsHouse('customsNumber', value)}
                            />
                        </div>
                        <div className="col-lg-4 col-md-2 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="text"
                                editViewActive={editing}
                                value={section}
                                label='Sección'
                                notify={(value) => this.updateCustomsHouse('section', value)}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="checkbox"
                                editViewActive={editing}
                                value={ownOffice}
                                notify={(value) => this.updateCustomsHouse('ownOffice', value)}
                                label="Cuenta con oficina propia"
                                customRender={() => boolToText(ownOffice)}
                            />
                        </div>
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-8 col-xs-5 vcenter hidden-lg-up">
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-7 vcenter edit-buttons text-center">
                        <div className="space-between">
                            {this.renderButtons(editing, customsHouse, onSave)}
                        </div>
                    </div>
                    <Alert
                        open={this.state.openAlert}
                        close={() => this.setState({ openAlert: false })}
                        message={"Seguro que quieres eliminar esta Aduana?"}
                        delteEntry={() => {
                            this.setState({ openAlert: false });
                            actions.deleteCustomsHouse(customsHouse);
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default Item;



// WEBPACK FOOTER //
// ./containers/aduanas/components/item.js